/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramGeoControllerGetCapitalQueryResponse,
  TelegramGeoControllerGetCapitalPathParams,
} from '../types/TelegramGeoControllerGetCapital.ts';

function getTelegramGeoGetCapitalUrl(countryId: TelegramGeoControllerGetCapitalPathParams['countryId']) {
  const res = { method: 'GET', url: `/api/telegram/geo/capital/${countryId}` as const };
  return res;
}

/**
 * {@link /api/telegram/geo/capital/:countryId}
 */
export async function telegramGeoGetCapital(
  countryId: TelegramGeoControllerGetCapitalPathParams['countryId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramGeoControllerGetCapitalQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramGeoGetCapitalUrl(countryId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
